export const FORUM_TOPIC_RESOURCE_TYPE = {
  LESSON_TEACHER_REVIEW: "LESSON_TEACHER_REVIEW",
  LESSON_ADMIN_REVIEW: "LESSON_ADMIN_REVIEW",
  MOE_LIBRARY_TEACHER_REVIEW: "MOE_LIBRARY_TEACHER_REVIEW",
  MOE_LIBRARY_ADMIN_REVIEW: "MOE_LIBRARY_ADMIN_REVIEW",
};

export const RESOURCE_TYPE = {
  POST: "POST",
};

export const DEFAULT_FORUM_PAGE_SIZE = {
  FORUM_TOPIC_LIST: 20,
};

export const NAMESPACE = {
  AUTH: "auth",
};
